/**
 * The pose model's identity, in ONE place, so the worker that loads it and the
 * benchmark that checks its reference cannot disagree.
 *
 * `scripts/benchmark-guard.js` fails the build unless
 * `public/benchmark/v1/reference.json` names this exact URL and version, and
 * unless POSE_DETECTION_VERSION equals the installed
 * `@tensorflow-models/pose-detection`. The pose server
 * (`truetoform_api/services/pose-inference/src/models.js`) carries the same URL
 * character for character.
 */
export const MOVENET_MODEL_URL =
  "https://storage.googleapis.com/truetoform-public/models/movenet/singlepose-lightning-v4-tfjs/model.json";

export const MOVENET_MODEL_NAME = "movenet/singlepose-lightning-v4-tfjs";

export const POSE_DETECTION_VERSION = "2.1.3";
